import { toRef } from 'vue';
import { useAnimatedCount } from '../../composables/useAnimatedCount.js';
import { useSparkline } from '../../composables/useSparkline.js';

export default (props) => {
  const { computedSparklineColor, computedGradient, chipColor, labelStyle } = useSparkline(props);

  // First change snaps, later changes animate (variant A); a null/undefined count shows 0
  const { displayCount } = useAnimatedCount(toRef(props, 'count'), { nullAsZero: true });

  return {
    computedSparklineColor,
    computedGradient,
    chipColor,
    labelStyle,
    displayCount,
  };
};
